/**
 * Test Routes Configuration
 *
 * This file defines all test pages available in development/local environments.
 * Test routes are automatically excluded from production builds.
 *
 * To add a new test page:
 * 1. Create your test page component in src/pages/test/YourTestPage.js
 * 2. Export it from src/pages/index.js (in the Test Pages section)
 * 3. Add an entry to TEST_ROUTES below
 *
 * @example
 * {
 *   path: '/guide/my-test',           // URL path
 *   componentName: 'MyTestPage',      // Component name from Pages export
 *   title: 'My Test Page',            // Display title
 *   description: 'Testing my component' // Optional description
 * }
 */

/**
 * @typedef TestRoute
 * @property {string} path - URL path for the test page (should start with /guide/)
 * @property {string} componentName - Name of the component exported from src/pages/index.js
 * @property {string} title - Display title for the test page
 * @property {string} [description] - Optional description of what the test page tests
 */

/** @type {TestRoute[]} */
export const TEST_ROUTES = [
  {
    path: '/guide/velo-card-test',
    componentName: 'VeloCardTest',
    title: 'VeloCard Component Test',
    description: 'Testing VeloQA components with all configurations'
  },
  {
    path: '/guide/charts-test',
    componentName: 'ChartsTest',
    title: 'Charts Component Test',
    description: 'Testing Chart components with sample market analysis data'
  }
];

